import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MyImmoHelpRoutingModule } from './myimmo-help-routing.module';
import { MyImmoHelpComponent } from './myimmo-help.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, MyImmoHelpRoutingModule, TranslateModule],
  declarations: [MyImmoHelpComponent],
})
export class MyImmoHelpModule {}
